import { useRouter } from 'next/navigation'
import type { FC } from 'react'
import { Trans } from 'react-i18next'

import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'

import type { INotification, INotificationRequisition } from '~/lib/features/notifications/types'

import NotificationItemLayout from './NotificationItemLayout'

const FullyApprovedRequisition: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const router = useRouter()
  const propertiesRelated = notification?.payload as INotificationRequisition

  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <>
          <TypographyText
            className="cursor-pointer text-sm text-gray-700"
            onClick={() => {
              onClick && onClick()
              router.push(
                `${configuration.path.requisitions.list}?id=${propertiesRelated.requisitionId}`
              )
            }}>
            <Trans
              i18nKey="activity:notification:fullyApprovedRequisition"
              values={{
                requisitionName: propertiesRelated?.requisitionName
              }}>
              <span className="font-medium text-gray-900" />
            </Trans>
            {time}
          </TypographyText>
        </>
      )}
    </NotificationItemLayout>
  )
}

export default FullyApprovedRequisition
